import React from 'react'
import AddFolderSvg from 'images/modules/Manage/i-folder-add.svg?raw'

export { default as AddFolderUrl } from 'images/modules/Manage/i-folder-add.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: AddFolderSvg}} />
)
